import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "./About.css"; // Optional: For adding styles
import Aboutus from "../../../Assets/image/about us 7 jan.webp";
import Design from "../../../Assets/image/vecteezy_decorative-gold-mandala01.png";
import Aboutusrod from "../../../Assets/image/dongard.webp";
import Tectcolor from "../../../Assets/image/7 JAN 6-30-min_11zon.webp";
import { Col, Row } from "reactstrap";
import logo from "../../../Assets/image/logo.png";
import Footer from "../footer/footer";
import Bar1 from "../../../components/navigationbar/navigationbar1";
import RevealBlurFX from "../../../components/Effect/RevealBlurFX";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const AboutUs = () => {

    const [isVisible, setIsVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    const handleScroll = () => {
        const currentScrollY = window.scrollY;

        if (currentScrollY > lastScrollY) {
            // Scrolling down
            setIsVisible(false);
        } else {
            // Scrolling up
            setIsVisible(true);
        }

        setLastScrollY(currentScrollY);
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [lastScrollY]);

    return (
        <>
            <Helmet>
                <title>About Us | Sandip electronics  & Automation | IoT & Solar Leaders</title>
                <meta name="description" content="Founded in 2013, Sandip electronics  & Automation (SEA) is a Pune-based pioneer in Solar Pump Controllers, IoT integration, and Power electronics . Learn about our mission to digitize Indian agriculture." />
                <meta name="keywords" content="Sandip electronics  and Automation history, Solar controller manufacturer  Pune(India), IoT energy solutions India, Mr. Sandip Kute, smart irrigation technology" />
                <meta property="og:title" content="Meet the Team Behind SEA Automation" />
                <meta property="og:description" content="From a small engineering firm to a leader in Solar IoT—read the story of Sandip electronics  and Automation." />
                <meta property="og:image" content="https://official.seaiot.in/assets/about-us-team.jpg" />
                <meta property="og:url" content="https://official.seaiot.in/about" />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://official.seaiot.in/about" />
            </Helmet>

            <div>
                <div className={`AppA ${isVisible ? "visible" : "hidden"}`}>
                    <div className="mylogo">
                        <div className="logo-container">
                            <Link to="/" className="cursor-pointer">
                                <img src={logo} alt="Logo" />
                            </Link>
                        </div>
                    </div>
                    <div className="bar-container">
                        <Bar1 />
                    </div>
                </div>

                <div className="containerab ">

                    <div className="plogo">
                        <img src={Aboutus} alt="Aboutus" title="Aboutus" style={{ width: '400px' }} />
                    </div>
                    <div className="div1">
                        <RevealBlurFX>
                            <div className="aboutcol1">
                                <h1 className="div1h1">
                                    Company Overview
                                </h1>
                                <p className="div1p">
                                    sandip electronics  And Automation (sea)
                                    Established in the year 2013 in Pune, Maharashtra,
                                    We sandip electronics  And Automation (SEA), a Sole Propriotership based firm.
                                    we are engaged as the foremost Manufacturer of Solar Pump controller, Solar Inverter,Hybrid Inverter, Auto Transformer Switch, Delay Timer,
                                    and more. Our products are in high demand due to their premium quality and affordability.
                                    Furthermore,we ensure the timely delivery of these products to our clients.through
                                    thiscommitment,we have gained a  substantial client base in the market.
                                    ○  expertise in power electronics , solar solutions, and embedded systems.
                                </p>
                            </div>
                        </RevealBlurFX>
                        <div className="aboutcol2">
                            <img src={Design} alt="Aboutus" title="Aboutus" style={{ width: '500px', }} />
                        </div>
                    </div>
                    <div>
                        <Row className="row p-2">
                            <Col lg={6} md={6} sm={12} >
                                <div className="rodlogo mt-2">
                                    <img src={Aboutusrod} alt="Aboutus" title="Aboutus" style={{ width: '100%', objectFit: 'cover' }} />
                                </div>
                            </Col>
                            <Col lg={6} md={6} sm={12}>
                                <RevealBlurFX>
                                    <div>
                                        <div className="div2">
                                            <h1 className="div2h1">
                                                Vision
                                            </h1>
                                            <p className="div2p">
                                                "To be a global leader in providing sustainable and innovative technology solutions
                                                that empower rural communities and enhance the productivity of micro-industries."
                                            </p>
                                        </div>
                                        <div className="div2">
                                            <h1 className="div2h1">
                                                Mission
                                            </h1>
                                            <p className="div2p">
                                                "To develop and deliver cutting-edge products in power electronics , solar energy,
                                                and automation to solve real-world challenges, create job opportunities, and
                                                drive positive environmental impact."
                                            </p>
                                        </div>
                                        <div className="div2">
                                            <h1 className="div2h1">
                                                Core Values
                                            </h1>
                                            <p className="div2p">
                                                ○ Innovation: Creating next-gen solutions for everyday problems.
                                                ○ Sustainability: Promoting eco-friendly, renewable energy solutions.
                                                ○ Community: Supporting rural development and creating local job opportunities.
                                                ○ Integrity: Delivering reliable, high-quality products that customers can trust.
                                            </p>
                                        </div>
                                    </div>
                                </RevealBlurFX>
                                <div className="p-2" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img src={Tectcolor} alt="Aboutus" title="Aboutus" style={{ height: '100%', width: '500px' }} />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                <Footer />            </div>
        </>
    );
};

export default AboutUs;

